// Store recent search
function saveRecentSearch(searchTerm) {
  if (!searchTerm || searchTerm.trim() === '') return;
  
  let recentSearches = JSON.parse(localStorage.getItem('recentSearches') || '[]');
  
  // Remove if already exists (to move to top)
  recentSearches = recentSearches.filter(term => term !== searchTerm);
  
  // Add to beginning
  recentSearches.unshift(searchTerm);
  
  // Keep only last 10 searches
  recentSearches = recentSearches.slice(0, 10);
  
  localStorage.setItem('recentSearches', JSON.stringify(recentSearches));
}

// Get recent searches
function getRecentSearches() {
  return JSON.parse(localStorage.getItem('recentSearches') || '[]');
}

// Display recent searches as pills
function displayRecentSearches() {
  const container = document.getElementById('recent-searches-container');
  const list = document.getElementById('recent-searches-list');
  
  if (!container || !list) return;
  
  const recentSearches = getRecentSearches();
  
  if (recentSearches.length === 0) {
    container.style.display = 'none';
    return;
  }
  
  // Clear existing pills
  list.innerHTML = '';
  
  // Create pills for each recent search
  recentSearches.forEach(term => {
    const pill = document.createElement('a');
    pill.href = `/search?q=${encodeURIComponent(term)}`;
    pill.textContent = term;
    pill.style.cssText =
      'display: inline-block; background-color: #f3f4f6; padding: 0.75rem 1.35rem; border-radius: 9999px; font-size: 1.35rem; font-weight: 500; text-decoration: none; color: inherit; transition: all 0.2s ease; margin: 0.45rem; box-shadow: 0 1px 3px rgba(0,0,0,0.08);';
    
    // Add hover effect
    pill.addEventListener('mouseenter', function() {
      this.style.backgroundColor = '#e5e7eb';
      this.style.transform = 'translateY(-2px)';
      this.style.boxShadow = '0 4px 7px rgba(0, 0, 0, 0.1)';
    });
    pill.addEventListener('mouseleave', function() {
      this.style.backgroundColor = '#f3f4f6';
      this.style.transform = 'translateY(0)';
      this.style.boxShadow = '0 1px 3px rgba(0,0,0,0.08)';
    });
    
    list.appendChild(pill);
  });
  
  container.style.display = 'block';
}

// Initialize on search page
document.addEventListener('DOMContentLoaded', function() {
  // Display recent searches on page load
  displayRecentSearches();
  
  // Save search term when form is submitted
  const searchForm = document.querySelector('form[action="/search"]');
  if (searchForm) {
    searchForm.addEventListener('submit', function() {
      const searchInput = this.querySelector('input[name="q"]');
      if (searchInput && searchInput.value.trim()) {
        saveRecentSearch(searchInput.value.trim());
      }
    });
  }
});
